import SeoManagement from '../SeoManagement';

/** Legacy page table + ops — embedded in control center. */
export default function SeoPagesList() {
  return <SeoManagement embedded />;
}
